const SWIGGY_INSTRUMENTS_PAYMENT_METHOD_PREFIX = "pm_si";

export const SWIGGY_INSTRUMENTS_PAYMENT_METHOD_TEST_IDS = {
    CONTAINER: `${SWIGGY_INSTRUMENTS_PAYMENT_METHOD_PREFIX}_container`,
    ICON: `${SWIGGY_INSTRUMENTS_PAYMENT_METHOD_PREFIX}_icon`,
    NAME: `${SWIGGY_INSTRUMENTS_PAYMENT_METHOD_PREFIX}_name`,
    BALANCE: `${SWIGGY_INSTRUMENTS_PAYMENT_METHOD_PREFIX}_bal`,
    TICK: `${SWIGGY_INSTRUMENTS_PAYMENT_METHOD_PREFIX}_tick`,
    LOW_BALANCE_ALERT: `${SWIGGY_INSTRUMENTS_PAYMENT_METHOD_PREFIX}_low_bal_alert`,
    PAY_BUTTON: `${SWIGGY_INSTRUMENTS_PAYMENT_METHOD_PREFIX}_pay_btn`,
    DISABLE_MESSAGE: `${SWIGGY_INSTRUMENTS_PAYMENT_METHOD_PREFIX}_disable_msg`,
    ADD_MONEY_CTA: `${SWIGGY_INSTRUMENTS_PAYMENT_METHOD_PREFIX}_add_money_cta`,
};
